import { Feature, FeatureCollection } from 'geojson'
import { Location } from '../map-layers-and-sources/common'

export class GeoJSONConverter {
  public static parse(locations: Location[]): FeatureCollection {
    const features: Feature[] = []
    //Remove white spaces from location_types a.k.a iconTypes otherwise it crashes the Map's icons
    const noWhiteSpaces = locations.map((location: Location) => {
      if (location.location_types === 'Harbour with Yacht Facilities') {
        return {
          ...location,
          location_types: 'Harbour With Yacht Facilities'?.replace(/\s+/g, '')
        }
      }

      return {
        ...location,
        location_types: location.location_types?.replace(/\s+/g, '')
      }
    })

    // Helper function to convert a single location to a GeoJSON Feature
    const convertToFeature = (location: Location): Feature => {
      const locationTypes = location.location_types?.split(',')
      const hasMultipleLocationTypes =
        locationTypes && locationTypes?.length > 1

      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [location.lng, location.lat]
        },
        properties: {
          id: location.id,
          path: location.path,
          name: location.name,
          region: location.region,
          iconType: hasMultipleLocationTypes
            ? locationTypes[0]
            : location.location_types ?? 'Area',
          facilities: location.facilities,
          book: location.book,
          edition: location.edition,
          chapter: location.chapter,
          position: { longitude: location.lng, latitude: location.lat }
        }
      }
    }

    // Iterate over each location and its possible nested multiple locations
    noWhiteSpaces.forEach((location: Location) => {
      features.push(convertToFeature(location))

      // Check if there are multiple nested locations
      if (location.multiple_locations) {
        location.multiple_locations.forEach(nestedLocation => {
          features.push(convertToFeature(nestedLocation))
        })
      }
    })

    return {
      type: 'FeatureCollection',
      features
    } as FeatureCollection
  }
}
